module.exports = __webpack_public_path__ + "static/copywriting-6a2292410bd1d2e65805fd4288488c4c.jpg";